module.exports = __webpack_public_path__ + "img/class-note.ea274324.png";